"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _StandardIconWrapper = _interopRequireDefault(require("./StandardIconWrapper"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var LayersIcon =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(LayersIcon, _React$PureComponent);

  function LayersIcon() {
    _classCallCheck(this, LayersIcon);

    return _possibleConstructorReturn(this, _getPrototypeOf(LayersIcon).apply(this, arguments));
  }

  _createClass(LayersIcon, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          color = _this$props.color,
          className = _this$props.className,
          props = _objectWithoutProperties(_this$props, ["color", "className"]);
      /* eslint-disable max-len */


      return _react.default.createElement(_StandardIconWrapper.default, _extends({
        className: (0, _classnames.default)(className, 'layers-icon')
      }, props), _react.default.createElement("path", {
        fill: color,
        d: "M2.01830345,7.37219748 C2.27938307,7.23539081 2.58691815,7.23539081 2.84892688,7.37219748 L2.84892688,7.37219748 L5.58422373,8.80042035 C5.84530335,8.93722703 6.15376754,8.93722703 6.41577627,8.80042035 L6.41577627,8.80042035 L9.15107312,7.37219748 C9.41215275,7.23539081 9.71968782,7.23539081 9.98076744,7.37219748 L9.98076744,7.37219748 L10.7435659,7.77000412 C11.085478,7.94853198 11.085478,8.4588888 10.7435659,8.63838691 L10.7435659,8.63838691 L6.41577627,10.8981227 C6.15376754,11.0339591 5.84530335,11.0339591 5.58422373,10.8981227 L5.58422373,10.8981227 L1.25643408,8.63838691 C0.914521973,8.4588888 0.914521973,7.94853198 1.25643408,7.77000412 L1.25643408,7.77000412 Z M6.41577627,1.09517924 L10.7435659,3.20634542 C11.085478,3.37404217 11.085478,3.85084484 10.7435659,4.01763513 L6.41577627,6.12880131 C6.15376754,6.25661343 5.84530335,6.25661343 5.58422373,6.12880131 L1.25643408,4.01763513 C0.914521973,3.85084484 0.914521973,3.37404217 1.25643408,3.20634542 L5.58422373,1.09517924 C5.84530335,0.968273587 6.15376754,0.968273587 6.41577627,1.09517924 Z"
      }));
      /* eslint-enable max-len */
    }
  }]);

  return LayersIcon;
}(_react.default.PureComponent);

exports.default = LayersIcon;
LayersIcon.defaultProps = {
  color: 'inherit'
};
LayersIcon.propTypes = {
  className: _propTypes.default.string,
  color: _propTypes.default.string
};